import { render } from "./SimpleTreeChildren.vue?vue&type=template&id=2aca0742&scoped=true"
import script from "./SimpleTreeChildren.vue?vue&type=script&lang=js"
export * from "./SimpleTreeChildren.vue?vue&type=script&lang=js"

import "./SimpleTreeChildren.vue?vue&type=style&index=0&id=2aca0742&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2aca0742"

export default script